import Divider from 'fe-design-base/molecules/Divider';

const MenuDivider = () => <Divider spacing={8} />;

export default MenuDivider;
